import { TabpanelScrollContainerTestIdSuffix } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { cssClass } from '../../style';

export namespace AuthorizableTypeSelectorStyles {
  const AuthorizableTypeSelectorCssPrefix = 'AuthorizableTypeSelector';

  export const titleMarginBottom = 18;
  export const tabsHeight = 36;
  export const tabsMarginTop = 20;
  export const tabsMarginBottom = 20;

  export const Container = cssClass(AuthorizableTypeSelectorCssPrefix, 'container', {
    display: 'flex',
    width: '100%',
    paddingTop: `${tabsMarginTop}px`,
  });

  export const TabsContainer = cssClass(AuthorizableTypeSelectorCssPrefix, 'tabs-container', {
    display: 'flex',
    flex: 1,
    borderBottom: '1px solid #e0e0e0',
    $nest: {
      [`& [data-tb-test-id$="${TabpanelScrollContainerTestIdSuffix}"]`]: {
        padding: '0px !important',
      },
    },
  });

  export const Tab = cssClass(AuthorizableTypeSelectorCssPrefix, 'tab', {
    flex: '1 1 0',
    minWidth: 0,
    padding: '12px 12px',
    border: 'none',
    background: 'none',
    fontSize: '0.875rem',
    color: '#444',
    cursor: 'pointer',
    borderBottom: '3px solid transparent',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center',
    transition: 'background-color 0.15s',
    $nest: {
      ':hover': {
        background: '#f5f5f5',
      },
      ':focus': {
        outline: '2px solid #1a73e8',
        outlineOffset: '-2px',
      },
    },
  });

  export const ActiveTab = cssClass(AuthorizableTypeSelectorCssPrefix, 'active-tab', {
    color: '#1a1a1a',
    fontWeight: 600,
    borderBottomColor: '#1a1a1a',
  });
}
